module.exports = __webpack_public_path__ + "images/heir-apparent-864f94ddba3fbb9be1844b291daa0fb3.png";